"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAppInsightsInitialized = exports.getAppInsights = exports.appInsightsService = void 0;
const applicationinsights_web_1 = require("@microsoft/applicationinsights-web");
const index_1 = require("../index");
let appInsights;
const createAppInsightsService = () => {
    /**
     * Initialize the Application Insights class
     * Details - https://github.com/Azure-Samples/application-insights-react-demo
     */
    const initialize = (instrumentationKey) => {
        if (!instrumentationKey) {
            index_1.Log.error("Instrumentation key not provided");
            return;
        }
        appInsights = new applicationinsights_web_1.ApplicationInsights({
            config: {
                instrumentationKey: instrumentationKey,
                maxBatchInterval: 0,
                disableAjaxTracking: true,
                disableCookiesUsage: true,
                disableFetchTracking: true,
            },
        });
        appInsights.loadAppInsights();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        appInsights.addTelemetryInitializer((envelope) => {
            const telemetryItem = (envelope === null || envelope === void 0 ? void 0 : envelope.tags) || [];
            telemetryItem["ai.accurx.userid"] = window.accurxUserId || "";
        });
    };
    return { appInsights, initialize };
};
exports.appInsightsService = createAppInsightsService();
const getAppInsights = () => appInsights;
exports.getAppInsights = getAppInsights;
const isAppInsightsInitialized = () => {
    const service = (0, exports.getAppInsights)();
    if (typeof window === "undefined" || !service) {
        return false;
    }
    return true;
};
exports.isAppInsightsInitialized = isAppInsightsInitialized;
//# sourceMappingURL=AppInsightsService.js.map